import { Outlet } from "react-router-dom";

import { InstallGate } from "@/components/install-gate/InstallGate";
import { useSurface } from "@/contexts/surface-context";
import { isSurfaceAllowed } from "@/lib/surface-override";

// Reusable route-level guard (Story 7.1) mirroring RoleGuard's <Outlet/>-or-fallback
// shape. On an iOS surface that is NOT a manifest-driven PWA it renders the Install Gate
// in place of its children; on `pwa-proper` and on any non-iOS surface (`other`) it is a
// transparent pass-through — desktop/Android clinicians are never gated.
//
// Enforcing (gh-469): the gate is a hard block. There is no "Continue anyway" escape and
// no session override — the only forward path on a gated surface is installing/opening
// the PWA, which re-classifies the surface (via the SurfaceProvider `display-mode`
// re-detect) and clears the gate. The allow rule is shared with the create flow
// (`lib/surface-override.ts`) so the two gated call-sites cannot diverge.

export function SurfaceGuard() {
  const { surface } = useSurface();

  if (!isSurfaceAllowed(surface)) {
    return <InstallGate surface={surface} />;
  }

  return <Outlet />;
}
